import { Component, HostBinding, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EnvironmentService } from '../../services/environment.service';

@Component({
    selector: 'app-environment',
    templateUrl: './environment.component.html',
    styleUrls: ['./environment.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EnvironmentComponent implements OnInit {
  environment: string;

  @HostBinding('class') class = this.environmentService.isProd() ? '' : 'env env--not-prod';

  constructor(private environmentService: EnvironmentService) {}

  ngOnInit(): void {
    this.environment = this.environmentService.environment;
  }
}
